export default __webpack_public_path__ + "static/media/Linkedin.6465defd.png";